/**
 * Texto para comparação: sem acento e sem diferença de maiúsculas, como a
 * busca do servidor (`ILIKE` e a collation do SQL Server).
 */
export const foldText = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();

/** Cada palavra da busca aparece em algum dos textos. */
export function matchesSearch(
  search: string,
  ...texts: (string | null | undefined)[]
): boolean {
  const haystack = foldText(texts.filter(Boolean).join(' '));
  return foldText(search)
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => haystack.includes(word));
}
